import { ModelSnippetFn } from '../types';

const getMcpClientSnippet = (mcpUrl: string, pat: string): string => `\
import asyncio
import os
from fastmcp import Client
from fastmcp.client.transports import StreamableHttpTransport

transport = StreamableHttpTransport(url="${mcpUrl}",
                                    headers={"Authorization": "Bearer " + ${pat}})

async def main():
  async with Client(transport) as client:
    tools = await client.list_tools()
    print(f"Available tools: {tools}")
    # TODO: update the dictionary of arguments passed to call_tool to make sense for your MCP.
    result = await client.call_tool(tools[0].name, {"a": 5, "b": 3})
    print(f"Result: {result[0].text}")

if __name__ == "__main__":
  asyncio.run(main())
`;

const getMcpAPIUrl = ({
  userId,
  appId,
  modelId,
  versionId,
  baseUrl = 'https://api.clarifai.com',
}: {
  userId: string;
  appId: string;
  modelId: string;
  versionId?: string;
  baseUrl?: string;
}) => {
  if (!versionId) {
    return `${baseUrl}/v2/ext/mcp/v1/users/${userId}/apps/${appId}/models/${modelId}`;
  }

  return `${baseUrl}/v2/ext/mcp/v1/users/${userId}/apps/${appId}/models/${modelId}/versions/${versionId}`;
};

export const generatePythonSDKForLLMMcp: ModelSnippetFn = ({ userId, appId, modelId, modelVersionId, pat }) => {
  return getMcpClientSnippet(
    getMcpAPIUrl({
      userId,
      appId,
      modelId,
      versionId: modelVersionId,
    }),
    pat && pat !== 'YOUR_PAT_HERE' ? `"${pat}"` : 'os.environ["CLARIFAI_PAT"]',
  );
};
